// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.authenticated-page-container {
  display: flex;
  flex-direction: column;
  flex:1 1;
  overflow: scroll;
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Authenticated/AuthenticatedPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAM;EACN,gBAAgB;AAClB","sourcesContent":[".authenticated-page-container {\n  display: flex;\n  flex-direction: column;\n  flex:1;\n  overflow: scroll;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
